import { useState } from "react";
import "./styles/Reviews.css";
import Header from "./Header";
import Footer from "./Footer";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL =
    "https://stari-vlah-strapi-54837937b4c4.herokuapp.com/api/reviews?sort=createdAt:desc";

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();
        console.log(data);

        if (data && data.data) {
          setReviews(data.data);
        } else {
          setReviews([]);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);
  return (
    <>
      <Helmet>
        <title>
          Recenzije gostiju | Apartman Stari Vlah Zlatibor | Smeštaj Zlatibor
        </title>
        <meta
          name="description"
          content="Pročitajte recenzije i iskustva gostiju koji su boravili u Apartmanu Stari Vlah Zlatibor. Saznajte zašto nas gosti preporučuju za smeštaj na Zlatiboru!"
        />
        <meta
          name="keywords"
          content="recenzije apartmani Zlatibor, iskustva gostiju Zlatibor, mišljenja gostiju apartman Zlatibor, komentari smeštaj Zlatibor, najbolji apartmani Zlatibor, ocene apartmani Zlatibor, gosti preporučuju smeštaj Zlatibor, apartman Stari Vlah iskustva"
        />
      </Helmet>
      <Header />
      <div className="mainReviewDiv">
        <div className="reviewImageDiv">
          <img src="/images/reviewsImg.jpg" className="reviewMainImg" />
          <motion.h2 className="mainReviewHeader" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>Recenzije gostiju</motion.h2>
          <motion.h3 className="mainReviewHeader2" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>
          Ništa ne govori bolje o našem apartmanu od reči naših gostiju. Pogledajte njihove recenzije i otkrijte šta možete očekivati tokom svog boravka!
          </motion.h3>
          <h1 className="reviewNameHeader">Apartman Stari Vlah</h1>
        </div>

        <div className="reviewListDiv">
          {loading ? (
            <p>Učitavanje recenzija...</p>
          ) : Array.isArray(reviews) && reviews.length > 0 ? (
            reviews.map((review) => (
              <motion.div key={review.id} className="reviewDiv" initial={{ y:100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8,}}
              viewport={{ once: true, amount: 0.7 }}>
                <img src="/images/pineImg.webp" className="pineImg" />
                <div className="reviewHeadDiv">
                  <img
                    src={
                      review.FemaleOrMale === "Female"
                        ? "/images/female.png"
                        : "/images/male.png"
                    }
                    className="reviewUserIcon"
                    alt="Ikona korisnika | Apartman Stari Vlah Zlatibor"
                  />
                  <div className="reviewUserDetailsDiv">
                    <p className="reviewName">{review.guestName}</p>
                    <p className="reviewCountry">{review.guestCountry}</p>
                  </div>
                  <p className="reviewDate">{review.reviewDate}</p>
                </div>
                <p className="reviewText">{review.reviewText}</p>
              </motion.div>
            ))
          ) : (
            <p>No reviews available.</p>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Reviews;
